import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';

export const useExportMenuSectionTitle = (): ActionMenuOption => {
  const { t } = useTranslation();
  return {
    as: AllowedActionMenuElements.Title,
    content: t('indexPage.pageActions.exportMenuSection'),
    id: 'export-title',
  };
};
